<div class="page" >
  <div class="content" *ngIf="user">
     Welcome {{user.name}}
    <h1>Dashboard</h1>
    <button mat-raised-button (click)="logout()">Logout</button>
  </div>
</div>
